import React, { useState, useEffect } from "react";
import FetchDeviceTypeField from "./FetchDeviceTypeField";
import FetchCommandField from "./FetchCommandField";
import { loadDeviceTypes } from "../../devices/deviceService";
import { ChevronDown } from 'lucide-react';


export default function FetchDeviceConfigCommandSection() {

  const initialState = {
    fetchCommand: '',
    selectedDeviceType: null
  }

  const [state, setState] = useState(initialState);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  const fetchData = async () => {
    try {
      const deviceTypeList = await loadDeviceTypes();
      setDeviceTypes(deviceTypeList);
          //setState({...state, selectedDeviceType: deviceTypeList[0]});
          //setState(device)
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);


      // const onDeviceTypeChange = (value) => setState({...state, selectedDeviceType: value, selectedCommand: null});
      // const onDeviceTypeChange=() => {};

  const onDeviceTypeChange = (value, fetchCommand) => {
    let strFetchCommand = "";
    if (fetchCommand !== "") {
      strFetchCommand = fetchCommand.value;
    }

    setState({
      ...state,
      selectedDeviceType: value,
      fetchCommand: strFetchCommand,
    });
  };

  const onFetchCommandChange = (value) => {
    setState({
      ...state,
      fetchCommand: value
    });
  };


      // const onSetCommandClick = event => {       
      //   showInfoToast('Saving DeviceType Fetch Configuration Command', 'DeviceType Configuration Command');

      //   setPopup(
      //     getConfirmPopup('Are you sure?',
      //         'DeviceType Configuration Command',
      //         () => onConfirm()
      //     )
      //   );

      //   const onConfirm = async ()=> {        
      //     await saveDeviceTypeFetchConfigCommand(command); 
      // };
      // };
      
      
      // const changeCommand= (value) => {setCommand(value);}
      // <DeviceTypeField deviceTypes={deviceTypes} value={state.selectedDeviceType} onChange={onDeviceTypeChange}/>
  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Fetch DeviceType Configuration Command</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <p className="oct_settings-description">
          This Command should be executed each time analysis run on a device of that type to fetch its configuration and save it to a file for further analysis.
        </p>

        <FetchDeviceTypeField deviceTypes={deviceTypes} value={state.selectedDeviceType} onChange={onDeviceTypeChange} />
        <FetchCommandField value={state.fetchCommand} deviceType={state.selectedDeviceType} onChange={onFetchCommandChange} />
      </div>
    </>
  );
}

    //        <div className="pl-2 row"> 
    //         <div className="ml-2">          
    //           <div className="row">
    //           <FetchDeviceTypeField deviceTypes={deviceTypes} value={state.selectedDeviceType} onChange={onDeviceTypeChange}/>
    //           <SSHAlgorithmField value={state.sshAlgorithm} device={state.selectedDevice} onChange={onAlgorithmChange}/>  
                
    //             <div className="col">
    //             <div className="col oct_paddingtop-six">
    //                 <label htmlFor="commandText">Fetch Command</label>
    //             </div>                
    //                 <input className="oct_form-control-default oct_textalign-center" 
    //                     type="text" 
    //                     value={command}
    //                     onChange={event => changeCommand(event.target.value)}/> 
    //             </div>
                
    //           </div>
    //         </div>
            

    //           <div className="row">
    //             <div className="col">
    //               <div className="oct_form-control-default oct_border-none"> 
    //                 <pre>

    //                 </pre>
    //               </div>
    //             </div>
    //           </div>
                    
            
    //       </div>
           
            
    //       </div>
    //     </>
    //   );        
    // }
